module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v("Vue-backtotop")]), _vm._v(" "), _c('p', [_vm._v("Change the values and scroll down the page to see the button :D")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_vm._m(0), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visibleoffset),
      expression: "visibleoffset"
    }],
    attrs: {
      "type": "text",
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57"
    },
    domProps: {
      "value": (_vm.visibleoffset)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.visibleoffset = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_vm._m(1), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_vm._m(2), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bottom),
      expression: "bottom"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bottom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bottom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-control"
  }, [_vm._m(3), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.right),
      expression: "right"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.right)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.right = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('h2', [_vm._v("Footer")]), _vm._v(" "), _c('back-to-top', {
    class: {
      'vue-back-to-top--is-footer': _vm.isBackTopFooter
    },
    attrs: {
      "visibleoffset": _vm.visibleoffset,
      "text": _vm.text,
      "bottom": _vm.bottom,
      "right": _vm.right,
      "scrollFn": _vm.scrollFn
    },
    on: {
      "scrolled": _vm.scrolled
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_c('strong', [_vm._v("Visible on scroll, in px")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_c('strong', [_vm._v("Button text")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_c('strong', [_vm._v("Bottom")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": ""
    }
  }, [_c('strong', [_vm._v("Right")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fork-me"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/caiofsouza/vue-backtotop",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://cdn4.iconfinder.com/data/icons/iconsimple-logotypes/512/github-512.png",
      "width": "30",
      "alt": "Fork me on Github",
      "title": "Fork me on Github"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2488d613","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 12
// module chunks = 0